import { createSelector } from 'reselect';
import { connect } from 'react-redux';

import registrationApi from '../../../api/registrationApi';

// eslint-disable-next-line import/no-cycle
import { checkTrustEligibility, resetTrustValidationResult, saveTrustDetails } from './actions';
import { selectTrustValidationResult, selectMainTrustDeedAttachment } from '../../../selectors';
import LocateYourTrust from './Component';

const mapStateToProps = createSelector(
  selectTrustValidationResult,
  selectMainTrustDeedAttachment,
  (validationResult, trustDeedAttachmentConfig) => ({
    validationResult,
    trustDeedAttachmentConfig,
  }),
);

// eslint-disable-next-line arrow-body-style
const mapDispatchToProps = (dispatch) => {
  return {
    isEligible: (abn) => dispatch(checkTrustEligibility(abn)),
    submitTrustDetails: (values, callback) => dispatch(saveTrustDetails(values, callback)),
    resetValidationResult: () => dispatch(resetTrustValidationResult()),
    searchTrust: (keyword) => registrationApi.searchTrust(keyword),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocateYourTrust);
